<template>
  <div>
    <TopBar :pagetitle="title" back-url="/textbook/license" />
    <div v-if="certification && certification.license" class="topBack">
      <!-- <img :src="certification.license.imageFront"> -->
      <div class="imgs" @click="onShowPreview(certification.license.imageBack)">
        <van-swipe :autoplay="5000">
          <van-swipe-item>
            <img :src="certification.license.imageBack">
          </van-swipe-item>
          <van-swipe-item>
            <img :src="certification.license.imageFront">
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div v-if="certification && certification.license" class="topImage">
      <!--  -->
      <!-- <img :src="certification.license.imageFront"> -->
      <img :src="certification.license.imageFront">
    </div>
    <div class="infoList ">
      <van-row class="item">
        <van-col span="18">
          <div class="pageTitle1 title">我的资料 /MY INFORMATION</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">国家 COUNTRY:</van-col>
            <van-col span="10">{{ getCountryText(certification.user.country) }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">姓名 NAME:</van-col>
            <van-col span="10">{{ certification.user.firstName.toUpperCase() }} {{ certification.user.lastName.toUpperCase() }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">生日 BIRTHDAY:</van-col>
            <van-col span="10">{{ formatDate(certification.user.birthday,"yyyy-MM-dd") }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">性别 SEX:</van-col>
            <van-col span="10">{{ certification.user.sex }}</van-col>
          </van-row>
        </van-col>
        <van-col span="6" style="text-align:right"><img class="iconHead" :src="certification.user.iconImage"></van-col>
      </van-row>

      <van-row class="item">
        <van-col span="23">
          <div class="pageTitle1 title">证书信息 /CERTIFICATION</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">证书名称 NAME:</van-col>
            <van-col span="13">{{ certification.license.nameFull }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">潜水次数 TICK:</van-col>
            <van-col span="13">{{ certification.license.dives }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">编号 LICENSE ID:</van-col>
            <van-col span="13">{{ certification.license.certificationId }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">签发日期 DATE:</van-col>
            <van-col span="13">{{ formatDate(certification.license.dateIssue,"yyyy-MM-dd") }}</van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="item">
        <van-col span="18">
          <div class="pageTitle1 title">潜店信息 /DIVE CENTER</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">中心 CENTER:</van-col>
            <van-col span="10">{{ certification.license.divecenterName }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">中心编号 CENTER ID:</van-col>
            <van-col span="10">{{ certification.license.divecenterNumber }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">地区 CITY:</van-col>
            <van-col span="10">{{ certification.license.divecenterCity }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">国家 COUNTRY:</van-col>
            <van-col span="10">{{ certification.license.divecenterCountry }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">教练 INSTRUCTOR:</van-col>
            <van-col span="10">{{ certification.license.instructorName }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">教练编号 INSTRUCTOR ID:</van-col>
            <van-col span="10">{{ certification.license.instructorNumber }}</van-col>
          </van-row>
        </van-col>
        <!-- <van-col span="6" class="pagebody3 center aboutStr"><img class="qrcode" src="/qr.png"><br>电子核验</van-col> -->
      </van-row>
      <!-- <van-button type="info" size="large" :loading="regPhoneLoading" @click="getPhysics">获取塑料潜水证书</van-button> -->
      <van-button type="info" size="large" @click="onShre">分享我的卡片</van-button>
    </div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareDesc" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" />
  </div>
</template>
<script>
import { Button, Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant'
import request from '@/utils/request'
import { GetSelfUrl } from '@/utils/request'
import TopBar from '@/components/TopBar'
import wxShare from '@/components/wxShare'
import { initPage, getUrlKey, MyNotify, formatDate, getCountryText } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [ImagePreview.name]: ImagePreview,
    TopBar,
    wxShare
  },
  data() {
    return {
      cardId: undefined,
      title: '资质卡片',
      certification: undefined,
      showShare: false,
      shareIcon: '',
      shareTimeline: '',
      shareDesc: '',
      shareTitle: '',
      shareUrl: ''
    }
  },
  created() {
    initPage(false)
    var url = getUrlKey('cardId')
    if (url !== null) {
      this.cardId = url
    } else {
      MyNotify('error', '证书不存在', 2000)
      this.$router.replace('/textbook/license')
    }
    request({
      url: '/user/getUserCertification',
      method: 'post',
      params: { cardId: this.cardId }
    }).then(response => {
      console.log(response)
      this.certification = response.data
      this.shareIcon = this.certification.license.imageFront
      this.shareTimeline = '我是SSI ' + this.certification.license.nameFull + '等级潜水员，我已获得' + response.data.licenseNum + '张SSI潜水证书。'
      this.shareDesc = '立即加入我们成为潜水员'
      this.shareTitle = '我已拥有SSI ' + this.certification.license.nameFull + '潜水员等级证书'
      this.shareUrl = GetSelfUrl() + 'textbook/card?i=' + this.certification.license.certificationId + '&c=' + this.certification.license.hashCode
    })
  },
  methods: {
    formatDate,
    getCountryText,
    getPhysics() {
      this.$router.replace('/textbook/licensePhysics?cardId=' + this.cardId)
    },
    onShre() {
      this.showShare = true
    },
    onShowPreview(url) {
      ImagePreview([url])
    }
  }
}
</script>

<style scoped>
.topBack{
    position:absolute;
    background-color: #000;
    width: 100%;
    height: 10em;
    text-align: center;
    padding-top: 0.5em;
}
/* .topBack div{
    padding: 0 1em;
} */
.topBack .imgs{
  margin: 0 1em;
  border-radius: 1em;
  overflow: hidden;
}
.topBack .imgs img{
  width: 100%;
  border-radius: 1em;
  overflow: hidden;
}
.topImage{
    text-align: center;
    padding: 0 1em;
}

.topImage img{
    width: 100%;
    margin-top: 0.5em;
    visibility: hidden;
}
.infoList{
    margin: 1em;
    line-height: 1.2em;
}
.infoList .item{
    border-bottom: 1px solid #ccc;
    margin: 1em 0;
    padding-bottom: 1em;
}
.infoList .title{
    margin-bottom: 1em;
}
.infoList .iconHead{
    width: 90%;
}
.infoList .qrcode{
    width: 100%;
}
</style>
